import script from "./TerminStepTraining.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminStepTraining.vue?vue&type=script&setup=true&lang=js"

import "./TerminStepTraining.vue?vue&type=style&index=0&id=4a49b6c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a49b6c8"]])

export default __exports__